import React, { useMemo, useState } from 'react';
import { ACTIVITY_CATEGORIES } from './activityQuery';

function ActivityCategoryPanel({ selectedCategory, onCategoryChange, loading = false }) {
    const [isOpen, setIsOpen] = useState(true);

    const activeLabel = useMemo(
        () => ACTIVITY_CATEGORIES.find((category) => category.value === selectedCategory)?.label || 'All',
        [selectedCategory]
    );

    return (
        <div className={`ecx-page-card ecx-page-panel activity-category-panel${isOpen ? '' : ' activity-category-panel--collapsed'}`}>
            <div className="ecx-page-panel__header activity-category-panel__header">
                <button
                    type="button"
                    className="activity-category-panel__toggle d-lg-none"
                    onClick={() => setIsOpen((open) => !open)}
                    aria-expanded={isOpen}
                    aria-controls="activity-category-panel-body"
                >
                    <div className="d-flex align-items-center gap-2 min-width-0">
                        <span className="ecx-page-icon-badge" style={{ width: '2rem', height: '2rem' }}>
                            <i className="bi bi-tags"></i>
                        </span>
                        <div className="text-start min-width-0">
                            <h6 className="mb-0 fw-semibold">Category</h6>
                            {!isOpen && (
                                <span className="activity-category-panel__active small text-muted text-truncate d-block">
                                    {activeLabel}
                                </span>
                            )}
                        </div>
                    </div>
                    <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} activity-category-panel__chevron`}></i>
                </button>

                <div className="d-none d-lg-flex align-items-center gap-2">
                    <span className="ecx-page-icon-badge" style={{ width: '2rem', height: '2rem' }}>
                        <i className="bi bi-tags"></i>
                    </span>
                    <h6 className="mb-0 fw-semibold">Category</h6>
                </div>
            </div>

            <div id="activity-category-panel-body" className="ecx-page-panel__body ecx-page-scroll activity-category-panel__body">
                <div className="activity-category-list">
                    {ACTIVITY_CATEGORIES.map((category) => (
                        <button
                            key={category.value}
                            type="button"
                            className={`activity-category-item ${
                                selectedCategory === category.value ? 'is-active' : ''
                            }`}
                            onClick={() => onCategoryChange(category.value)}
                            disabled={loading}
                        >
                            <span className="activity-category-item__icon">
                                <i className={`bi ${category.icon}`}></i>
                            </span>
                            <span className="activity-category-item__label">{category.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ActivityCategoryPanel;
